import { useTranslation } from 'react-i18next';

import { CompanyLogoImage } from 'components/common/CompanyLogo';
import VerifiedBadge from 'components/common/VerifiedBadge';

import styles from './styles.module.scss';

const starIconSrc = new URL('../../../img/star-full.svg', import.meta.url).href;

interface CompanyHeaderProps {
  companyData: any;
  companyLogo: string;
}

export default function CompanyHeader({ companyData, companyLogo }: CompanyHeaderProps) {
  const { t } = useTranslation();

  const rating = companyData.ratings?.rate;
  const reviewsCount = companyData.ratings?.total;
  const dealsCount = companyData.deals_count;
  const companyRole = companyData.company_roles;

  return (
    <div className={styles.header}>
      <div className={styles.headerLogo}>
        <CompanyLogoImage
          mode={companyLogo}
          className={companyLogo ? styles.logoImage : styles.logoPlaceholder}
        />
      </div>

      <div className={styles.headerInfo}>
        <div className={styles.headerTop}>
          <div className={styles.headerNameRow}>
            <h1 className={styles.companyName}>{companyData.name}</h1>
            <VerifiedBadge isVerified={companyData.is_verified} />
          </div>
          {/* TODO: */}
          {/* <button className={styles.writeButton}>
            {t('companyPage.write')}
          </button> */}
        </div>

        {companyRole && (
          <span className={styles.companyType}>{companyRole}</span>
        )}

        <div className={styles.ratingRow}>
          {rating > 0 && (
            <div className={styles.ratingGroup}>
              <img src={starIconSrc} alt={t('companyPage.rating')} className={styles.starIcon} />
              <span className={styles.ratingValue}>{Number(rating).toFixed(1)}</span>
            </div>
          )}
          {reviewsCount > 0 && (
            <span className={styles.reviewsCount}>
              {reviewsCount} {t('companyPage.reviews')}
            </span>
          )}
          {dealsCount > 0 && (
            <span className={styles.dealsCount}>
              {dealsCount} {t('companyPage.deals')}
            </span>
          )}
        </div>
      </div>

        {/* TODO: */}
        {/* <div className={styles.writeButtonMobile}>
            <button className={styles.writeButtonFull}>
            {t('companyPage.write')}
            </button>
        </div> */}
    </div>
  );
}
